import { render, staticRenderFns } from "./popup-seal.vue?vue&type=template&id=abd0c76a&scoped=true"
import script from "./popup-seal.vue?vue&type=script&lang=js"
export * from "./popup-seal.vue?vue&type=script&lang=js"
import style0 from "./popup-seal.vue?vue&type=style&index=0&id=abd0c76a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd0c76a",
  null
  
)

export default component.exports